import React, { useEffect, useState } from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [appetizers, setappetizers] = useState(false);
   

    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };

    const Item = ({ item }) => {
        const [image, setImage] = useState(false);

        useEffect(() => {
            fetchImage(`menu-cat-${item.id}`).then((url) => {
                if (url) {
                    setImage(url);
                }
            });
        }, []);

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '48%',
                    position: 'relative',
                    cursor: 'pointer',
                }}
                onClick={() => {
                    setShowListProduct(true);
                    setdishs(item);
                }}
            >
                <p
                   
                    style={{
                        position: 'absolute',
                        color: 'white',
                        fontWeight: '900',
                        fontSize: 20,
                        textAlign: 'center',
                        paddingInline: 6,
                        fontFamily: 'Abril',
                    }}
                >
                    {item.name}
                </p>
                <img
                    onContextMenu={(e) => e.preventDefault()}
                    src={image}
                    style={{
                        marginTop: 6,
                        width: '100%',
                        height: 80,
                        pointerEvents: 'none',
                        objectFit: 'cover',
                        borderRadius: 14,
                        border: '1px solid #66C3A9',
                    }}
                />
            </div>
        );
    };


         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 718) {
                setappetizers(item);
            }
        });
    }, [menus]);


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)

         }, [goHomeInit]);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={false} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
                <div>
                    

                    <div style={{ width: '100%', position: 'relative', zIndex: 900, marginTop: -20}}>
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 390,
                            height: 110,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 1,
                                marginBottom: 10,
                            marginLeft: 20,
                            
                        }}
                        src={require('./assets/logo.png')}
                    />
                    </div>
                    
                    <div style={{paddingInline:50, boxSizing: 'border-box', marginBottom: 20}}>
                        <p style={{color: '#000', fontSize: 14, textAlign: 'center', color: '#fff', fontStyle: 'italic'}}>
                            * Please inform the waiter if you have any type of allergic condition. For your convenience, an 18% gratuity will be added to your bill.
                        </p>
                    </div>
                <div style={{ display: 'flex', width: '100%',  position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box', gap: 10 }}>
                       
                   
                         <div style={{ width: '50%'}}>
                            <img
                             
                            src={require('./assets/homebanner.png')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: 1,
                                width: '100%',
                                height: 438,
                                objectFit: 'contain',
                                borderRadius: 14,
                               
                               
                            }}
                        />

                    </div>

                        <div style={{ width: '50%' }} >
                            
                            <div style={{ marginBottom: 10 }}
                            
                                onClick={() => {
                                 setdishs(appetizers);
                                setShowListProduct(true);
                            }}
                            >
                                <img src={require('./assets/appetizers.png')} style={{ width: '100%', height: 120, objectFit: 'contain' }} />
                            </div>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                gap: 10,
                                height: 288,
                                overflowY: 'auto',
                                paddingRight: 4,
                                boxSizing: 'border-box',
                            }}
                        >
                            {menus.map((item, key) => {
                               if (![718].includes(item.id)) {
                                    return <Item item={item} key={key} />;
                                }
                            })}
                        </div>
                    </div>

                    
                </div>
               
            </div>

            <div
                    onClick={() => {
                        // setShowListProduct(true)
                        // setdishs(dataMothers)
                        //  setShowDetailProduct(true)
                 //   setDataDish({ dish: tomahawk, alldish: steak, currentDish: tomahawk })
               }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                
                    boxSizing: 'border-box',
                   
                    }}>
                    <img
                        onContextMenu={(e) => e.preventDefault()}
                        //src={require('./assets/bannerinferior.png')}
                        src={require('./assets/bannerinferior.png')}
                    style={{
                        width: '100%',
                        height: 254,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                         pointerEvents: 'none',
                       
                        
                        
                    }}
                    />
                {/* <img
                    src={require('./assets/banner.png')}
                    style={{
                        width: '100%',
                        height: 174,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginTop: -10,
                        marginLeft: 5
                        
                    }}
                    /> */}
                  
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
                
                {showCocktails && <Cocktails setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;